<div class="confirm-hire-list-bg" (click)="close()" @opacityInOut></div>
<div class="confirm-hire-list" @scaleInOut>
  <i class="app-ico-mask app-ico-mask__x" (click)="close()"></i>
  <div class="confirm-hire-list__header">
    <h1>{{ title || 'Confirm hire' | translate }}</h1>
  </div>

  <div class="confirm-hire-list__section">
    <div class="confirm-hire-list__loading" *ngIf="loading" @opacityInOut>
      <div class="main-loader"></div>
      <span>{{ 'VacanciesMatch.LoadingResults' | translate }}</span>
    </div>
    <div class="confirm-hire-list__search" *ngIf="!loading" @opacityInOut>
      <a-input 
        type="text"
        label="Search"
        [control]="searchControl"
        [isSearch]="true">
      </a-input>
      <div class="confirm-hire-list__hint" *ngIf="talentsList && talentsList.length">
        Please select the talent you want to hire.
      </div>
    </div>
    <div class="confirm-hire-list__items is-scroll">
      <div class="confirm-hire-list__item a-section"
        infinite-scroll
        [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="300"
        (scrolled)="onScrollDown($event)"
        *ngFor="let item of talentsList; let i = index;">
        <input
          id="radio-{{ i }}"
          [value]="item.talentId" 
          (change)="onChange($event)"
          [checked]="item.talentId === listControl.value" 
          name="radio" 
          type="radio">
        <label for="radio-{{ i }}" class="radio-label">
          <div>
            <div class="confirm-hire-list__item__name">{{ item.name }}</div>
            <div class="confirm-hire-list__item__salary" *ngIf="(item.salary | salary) as salaryText">
              <i class="app-ico-mask app-ico-mask__salary"></i>
              Salary - {{ salaryText }}
            </div>
          </div>
          <round-progress
            [small]="true" 
            [score]="item.matchScore">
          </round-progress>
        </label>
      </div>

      <div class="confirm-hire-list__no-matches" @opacityInOut
        *ngIf="!loading && (!talentsList || (talentsList && !talentsList.length))">
        <div class="confirm-hire-list__no-matches__inner">
          <i class="app-ico app-ico__empty-inbox"></i>
          <div>
            <h4>No available Talens found.</h4>
            <div class="confirm-hire-list__no-matches__subtext">
              Please write to more Talents or change search request.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="confirm-hire-list__btns">
    <div class="is-btn is-btn__outfill" (click)="close()">Cancel</div>
    <div class="is-btn" (click)="confirm()" [class.is-disabled]="listControl.invalid">Confirm</div>
  </div>
</div>